module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/chat-error-b59b26e2e301ff69b077c04be927c79c.svg";